import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { observer, inject } from 'mobx-react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import { Modal } from 'client/shared/components';

import CardForm from './card-form';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY);

@inject('userStore', 'formStore')
@observer
class CardModal extends React.Component {
	state = {
		modalOpen: false,
		activeCard: { card: null }
	}

	componentDidMount () {
		this.getCards();
	}

	@autobind
	async getCards () {
		const { userStore } = this.props;
		const member = userStore.getLoggedInUser();

		const list = await member.getCreditCardList();
		if (!_.isEmpty(list)) {
			this.setState({ activeCard: list[0] });
		}
	}

	render () {
		const {
			modalContentLabel = 'Manage Your Payment Methods'
		} = this.props;

		return (
			<div className="subscribe">
				<Modal
					isOpen={ this.state.modalOpen }
					onClose={ this.handleCloseModal }
					size="md"
					title="Manage Payment Method"
					contentLabel={ modalContentLabel }
					dataTa="card-modal"
					closeButtonDataTa="closeAddMemberModalBtn"
				>
					{ this.renderModalContent() }
				</Modal>

				<div className="section-title">Manage Payments</div>
				<button
					data-ta="edit-payment-button"
					className="button neo form mdl-wide"
					onClick={ this.handleOpenModal }
					style={ { width: '21vw' } }
				>
					Edit Payment
				</button>
			</div>
		);
	}

	renderModalContent () {
		if (this.props.userStore.isLoading) {
			return (
				<div
					className="loading-spinner large text-center"
					style={ { height: '40vh' } }
				/>
			);
		}

		return (
			<Elements stripe={ stripePromise }>
				<CardForm
					data-ta="card-form"
					activeCard={ this.state.activeCard }
					handleCloseModal={ this.handleCloseModal }
					notify={ this.props.notify }
					errorToast={ this.props.errorToast }
					redirectParams={ this.props.redirectParams }
				/>
			</Elements>
		);
	}

	@autobind
	handleOpenModal () {
		this.setState({ modalOpen: true });
		this.getCards();
	}

	@autobind
	handleCloseModal () {
		this.setState({ modalOpen: false });
	}
}

export default CardModal;
